var bg = {
  "Add Quantity Breaks to your product page": "Добавете отстъпки за количество към вашата продуктова страница",
  "Add Upsell.com to your ": "Добавете Upsell.com към вашата ",
  "All time": "За целия период",
  "and select": "и изберете",
  "button": "бутон",
  "Cart drawer page": "Страница Чекмедже на количката",
  "Cart page": "Страница Количка",
  "Check status": "Проверка на статуса",
  "Checkout page": "Страница за Плащане",
  "Click": "Кликнете",
  "Click on": "Кликнете върху",
  "Click the": "Кликнете върху",
  "Custom slot": "Персонализиран слот",
  "Custom slots": "Персонализирани слотове",
  "Custom Slots": "Персонализирани слотове",
  "contact support.": "свържете се с поддръжката.",
  "from the right sidebar": "от дясната странична лента",
  "Go to App Embeds": "Отидете на вгражданията на приложения",
  "Go to your Cart drawer page": "Отидете на вашата страница Чекмедже на количката",
  "Go to your Cart page": "Отидете на вашата страница Количка",
  "Go to your Checkout page": "Отидете на вашата страница за Плащане",
  "Go to your Order status page": "Отидете на вашата страница Статус на поръчката",
  "Go to your Post purchase page": "Отидете на вашата страница След покупка",
  "Go to your Product page": "Отидете на вашата Продуктова страница",
  "Go to your Thank you page": "Отидете на вашата страница Благодаря",
  "items": "артикули",
  "in the left sidebar": "в лявата странична лента",
  "Last 12 months": "Последните 12 месеца",
  "Last 30 days": "Последните 30 дни",
  "Last 365 days": "Последните 365 дни",
  "Last 7 days": "Последните 7 дни",
  "Last 90 days": "Последните 90 дни",
  "Last month": "Миналия месец",
  "Last year": "Миналата година",
  "Make sure": "Уверете се, че",
  "Need assistance? Contact our support team for help.": "Нуждаете се от помощ? Свържете се с нашия екип за поддръжка.",
  "Order status page": "Страница Статус на поръчката",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "Приложението ни в момента претърпява малко магия, за да подобри преживяването ви.",
  "Post purchase page": "Страница След покупка",
  "Product page": "Продуктова страница",
  "Save": "Запази",
  "Scroll to the bottom and select": "Превъртете до долу и изберете",
  "Select": "Изберете",
  "Success. Please continue.": "Успех. Моля, продължете.",
  "Thank you page": "Страница Благодаря",
  "The Upsell.com team.": "Екипът на Upsell.com.",
  "The Upsell.com widget is not placed on ": "Джаджата на Upsell.com не е поставена на ",
  ". Please follow the steps above or ": ". Моля, следвайте стъпките по-горе или ",
  "Today": "Днес",
  "toggle is on": "превключвателят е включен",
  "Total": "Общо",
  "under": "под",
  "We apologize for any inconvenience caused,": "Извиняваме се за причиненото неудобство,",
  "We apologize for any inconvenience caused.": "Извиняваме се за причиненото неудобство.",
  "We'll be done in a few minutes!": "Ще сме готови след няколко минути!",
  "We're improving our services!": "Подобряваме услугите си!",
  "Widget already added": "Джаджата вече е добавена",
  "Yesterday": "Вчера",
  "You enabled the widget in your online store but didn't save it in the Upsell editor": "Активирахте уиджета във вашия онлайн магазин, но не го запазихте в редактора на Upsell",
  "You placed the widget on the ": "Поставихте джаджата на ",
  ", but you didn't save it in Shopify editor. Please go back to ": ", но не я запазихте в редактора на Shopify. Моля, върнете се на ",
  " and save the changes.": " и запазете промените."
};

export { bg as default };
//# sourceMappingURL=bg.json.js.map
